"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var apps_shared_1 = require("@l2p/apps-shared");
var PreventSpaceDefault = function () {
    var isGamePage = (0, apps_shared_1.useCheckPageUrl)('game');
    (0, react_1.useEffect)(function () {
        var handleKeyDown = function (event) {
            if (event.code === 'Space' || event.key === ' ') {
                event.preventDefault();
            }
        };
        if (isGamePage)
            document.addEventListener('keydown', handleKeyDown);
        return function () {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [isGamePage]);
    return null;
};
exports.default = PreventSpaceDefault;
